import { render, staticRenderFns } from "./Forgot_pass.vue?vue&type=template&id=1e6b1f18&scoped=true&"
import script from "./Forgot_pass.vue?vue&type=script&lang=js&"
export * from "./Forgot_pass.vue?vue&type=script&lang=js&"
import style0 from "./Forgot_pass.vue?vue&type=style&index=0&id=1e6b1f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6b1f18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCardText,VCol,VForm,VRow,VSheet,VTextField})
